module.exports = __webpack_public_path__ + "static/media/event-series.57660a45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/event-series.svg
// module id = 109
// module chunks = 0